<template>
  <card title="Current Study" pull :icon="['fas', 'palette']">
    <Loader v-if="loading" />
    <template v-else>
      <span v-if="error">{{ error }}</span>
      <template v-else>
        <span class="h4 mb-1">{{ study.title }}</span>
        <span class="mb-1"
          ><app-date :date="study.deadline" prepend="Deadline"
        /></span>
        <hr />
        <span class="h4">
          {{ submissions.total }}
          {{ 'Submission' | pluralize(submissions.total) }}
        </span>
        <value-compare-bar
          :a="{ label: 'for critique', value: submissions.critique }"
          :b="{ label: 'for viewing', value: submissions.viewing }"
        />
      </template>
    </template>
  </card>
</template>

<script>
import Card from '@/components/global/Card';
import maddyApi from '@/services/maddyApi';
import Loader from '@/components/global/Loader';
import AppDate from '@/components/app/AppDate';
import ValueCompareBar from '@/components/admin/dashboard/ValueCompareBar';

export default {
  components: {
    Card,
    Loader,
    AppDate,
    ValueCompareBar,
  },
  data() {
    return {
      loading: true,
      study: null,
      submissions: {
        total: 0,
        viewing: 0,
        critique: 0,
      },
      error: null,
    };
  },
  async mounted() {
    await this.fetchStudy();
    await this.fetchSubmissions();
    this.loading = false;
  },
  methods: {
    async fetchStudy() {
      const response = await maddyApi.get('/studies?take=1&skip=0');
      const { data } = response;
      this.errorHandler(response);

      if (!this.error) {
        this.study = data.data[0];
      }
    },
    async fetchSubmissions() {
      const response = await maddyApi.get(`/studies/${this.study.id}/gallery`);
      this.submissions.total = response.data.length;
      this.submissions.critique = [...response.data].filter(
        s => s.critique,
      ).length;
      this.submissions.viewing =
        this.submissions.total - this.submissions.critique;
    },
    errorHandler(response) {
      const { status, data } = response;
      if (status !== 200) {
        this.error = 'Server error';
      }

      if (data._metadata.count < 1) {
        this.error = 'No results found';
      }
    },
  },
};
</script>
